import script from "./UserCardContent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCardContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__